
  import { defineComponent, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import * as Yup from 'yup';
  import { useI18n } from 'vue-i18n/index';
  import { useAbility } from '@casl/vue';
  import axios from 'axios';

  export default defineComponent({
    name: 'generate-otp',
    components: { ErrorMessage, Field, Form },
    setup() {
      const { t, te } = useI18n();
      const { can } = useAbility();
      const loading = ref(false);
      const otp = ref('');
      const error = ref('');

      const translate = (text: string) => (te(text) ? t(text) : text);

      const otpSchema = Yup.object().shape({
        phone: Yup.string()
          .required(() => translate('PHONE_IS_REQUIRED_FIELD'))
          .matches(/^[0-9]{8,15}$/, () => translate('INVALID_PHONE_NUMBER')),
      });

      const onSubmitGenerateOtp = async (values: { phone: string }) => {
        loading.value = true;
        otp.value = '';
        error.value = '';
        try {
          const response = await axios.post(
            `${process.env.VUE_APP_API_URL}/users/generate-otp`,
            { phone: values.phone }
          );
          otp.value = response.data.otp;
        } catch (err: any) {
          error.value = err.response?.data?.message || 'Failed to generate OTP';
        }
        loading.value = false;
      };

      return {
        can,
        translate,
        otpSchema,
        onSubmitGenerateOtp,
        loading,
        otp,
        error,
      };
    },
  });
